import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { DialogActions } from '@mui/material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import GhostButton from '../../shared/button/GhostButton';
import PrimaryButton from '../../shared/button/PrimaryButton';
import { BodyText, Subheading } from '../../shared/typography/PrimaryTypography';

/**
 * A modal confirming the resetting of all Readiness Gauge Instance responses.
 * @param {boolean} open The display state of the modal.
 * @param {string} questionnaire_name The display name of the Readiness Gauge Instance.
 * @param {void} handleCloseResetModal Handler to close the modal.
 * @param {void} handleReset Restart the Readiness Gauge.
 * @returns {JSX.Element}
 */
const ResetConfirmModal = ({
  open,
  questionnaire_name,
  handleCloseResetModal,
  handleReset
}: {
  open: boolean;
  questionnaire_name: string;
  handleCloseResetModal: () => void;
  handleReset: () => void;
}) => {
  const handleResetClick = async () => {
    handleReset();
    handleCloseResetModal();
  };

  return (
    <Dialog open={open} onClose={handleCloseResetModal}>
      <Subheading
        weight="Bold"
        sx={{ m: 2 }}
      >{`Are you sure you want to reset ${questionnaire_name}?`}</Subheading>
      <DialogContent>
        <BodyText id="reset-explainer">
          This will delete your responses to all questions and the Readiness Gauge will have to be
          filled out again.
        </BodyText>
        <DialogActions sx={{ mt: 2 }}>
          <GhostButton dark onClick={handleCloseResetModal}>
            Cancel
          </GhostButton>
          <PrimaryButton
            startIcon={<RestartAltIcon />}
            onClick={() => {
              handleResetClick();
            }}
            palette_color="error"
          >
            Reset
          </PrimaryButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ResetConfirmModal;
